<template>
  <div class="carbonfootprint-certificate">
    <el-form
      v-for="(ruleForm, index) in formList"
      :ref="`ruleForm${index}`"
      :key="index"
      :model="ruleForm"
      :disabled="type === 'detail'"
      :rules="rules"
      size="small"
      label-width="110px"
      label-suffix=":"
    >
      <div class="certificate-title">
        <div class="certificate-title-text">碳足迹证书{{ index + 1 }}</div>
        <eui-btn
          v-if="formList.length > 1 && componentType != 'single'"
          type="text"
          color="#E50113"
          @click="deleteCertificate(index)"
          >删除</eui-btn
        >
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="证书出具机构" prop="institutionName">
            <el-input
              v-model="ruleForm.institutionName"
              maxlength="255"
              placeholder="请输入证书出具机构"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="证书编号" prop="reportCode">
            <el-input
              v-model="ruleForm.reportCode"
              maxlength="100"
              placeholder="请输入证书编号"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="证书有效期" prop="validityPeriod">
            <el-date-picker
              v-model="ruleForm.validityPeriod"
              style="width: 100%"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="认证标准" prop="standard">
            <el-select
              v-model="ruleForm.standard"
              placeholder="请选择认证标准"
              style="width: 100%"
            >
              <el-option
                label="ISO 14067:2018《温室气体 产品碳足迹 关于量化的要求和指南》"
                :value="1"
              />
              <el-option
                label="PAS 2050:2011《商品和服务在生命周期内的温室气体排放评价规范》"
                :value="2"
              />
              <el-option
                label="GB/T 24067-2024《温室气体 产品碳足迹 量化要求和指南》"
                :value="3"
              />
              <el-option label="GHG Protocol《温室气体核算体系》" :value="4" />
              <el-option label="其他" :value="5" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="ruleForm.standard == 5" :span="12" class="remark">
          <el-input
            v-model="ruleForm.standardName"
            style="margin-top: 2px"
            maxlength="255"
            placeholder="请输入认证标准"
          ></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="18">
          <el-form-item label="认证物资类别" prop="certificateMaterialCategory">
            <certificateMaterialCategory
              :category="ruleForm.certificateMaterialCategory"
              @change="(value) => CategoryChange(value, index)"
            ></certificateMaterialCategory>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="产品名称" prop="productName">
            <el-input
              v-model="ruleForm.productName"
              maxlength="255"
              placeholder="请输入产品名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规格型号" prop="specifications">
            <el-input
              v-model="ruleForm.specifications"
              maxlength="255"
              placeholder="请输入规格型号"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="系统边界" prop="systemBoundary">
            <el-select
              v-model="ruleForm.systemBoundary"
              placeholder="请选择系统边界"
              style="width: 100%"
            >
              <el-option label="摇篮到大门（Cradle-to-Gate）​" :value="1" />
              <el-option label="大门到大门（Gate-to-Gate）​" :value="2" />
              <el-option label="摇篮到坟墓（Cradle-to-Grave）" :value="3" />
              <el-option label="摇篮到摇篮（Cradle-to-Cradle）" :value="4" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="时间边界" prop="timeBoundary">
            <el-date-picker
              v-model="ruleForm.timeBoundary"
              style="width: 100%"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="功能单位" prop="functionalUnit">
            <el-input
              v-model="ruleForm.functionalUnit"
              maxlength="100"
              placeholder="请输入功能单位，吨/米/个/台等"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-form-item
          class="cursor-form-item"
          label="每功能单位碳足迹数值"
          prop="carbonUnit"
        >
          <span
            ><el-radio
              v-model="ruleForm.carbonUnit"
              :label="2"
              @input="carbonUnitChange(index)"
              >千克二氧化碳当量（kgCO₂e）</el-radio
            >
            <el-input
              v-if="ruleForm.carbonUnit == 2"
              v-model="ruleForm.carbonUnitValue"
              maxlength="100"
              style="width: 305px"
              placeholder="请输入每功能单位碳足迹数值"
              @input="(val) => handleInput(val, index, 'carbonUnitValue')"
            ></el-input>
            <el-input
              v-else
              placeholder="请输入每功能单位碳足迹数值"
              style="width: 305px"
              disabled
            ></el-input>
          </span>

          <el-col :span="12">
            <span
              ><el-radio
                v-model="ruleForm.carbonUnit"
                :label="1"
                @input="carbonUnitChange(index)"
                >吨二氧化碳当量（tCO₂e）</el-radio
              >
              <el-input
                v-if="ruleForm.carbonUnit == 1"
                v-model="ruleForm.carbonUnitValue"
                maxlength="100"
                style="width: 266px"
                placeholder="请输入每功能单位碳足迹数值"
                @input="(val) => handleInput(val, index, 'carbonUnitValue')"
              ></el-input>
              <el-input
                v-else
                placeholder="请输入每功能单位碳足迹数值"
                style="width: 305px"
                disabled
              ></el-input>
            </span>
          </el-col>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="碳足迹证书" prop="attachmentList">
          <eui-upload
            ref="upload"
            :headers="headers"
            :file-list="ruleForm.attachmentList"
            :action="fileUrl"
            :auto-upload="autoUpload"
            :show-file-list="true"
            :limit="1"
            accept=".pdf"
            text="上传文件"
            :limit-file-size="30"
            tip="最多上传1个文件，格式为PDF，大小不超过30M"
            @handleSuccess="(res) => uploadSuccess(res, index)"
          ></eui-upload>
        </el-form-item>
      </el-row>
    </el-form>
    <div v-if="componentType != 'single'" class="add-from">
      <eui-btn
        v-if="formList.length < 5"
        type="weak"
        icon="eicon-add"
        style="--width: 100%"
        size="40"
        icon-position="left"
        @click="addCertificate"
        >新增产品碳足迹证书</eui-btn
      >
    </div>
    <!-- <el-button @click="submit">提交</el-button> -->
  </div>
</template>

<script>
import api from '@/modules/projectA/api/order';
import { epecToken } from '@/modules/projectA/utils/globalData';
import certificateMaterialCategory from './certificateMaterialCategory.vue';

export default {
  name: 'CarbonfootprintCertificate',
  components: {
    certificateMaterialCategory,
  },
  props: {
    certificate: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    componentType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      headers: epecToken,
      fileUrl: api.fileUploadForGreenPdfAndPic,
      autoUpload: true,
      formList: [
        {
          institutionName: '',
          reportCode: '',
          validityPeriod: [],
          standard: '',
          standardName: '',
          productName: '',
          certificateMaterialCategory: [],
          specifications: '',
          systemBoundary: '',
          timeBoundary: [],
          functionalUnit: '',
          carbonUnit: '',
          carbonUnitValue: '',
          attachmentList: [],
        },
      ],
      rules: {
        institutionName: [
          { required: true, message: '请输入证书出具机构', trigger: 'blur' },
        ],
        reportCode: [
          { required: true, message: '请输入证书编号', trigger: 'blur' },
        ],
        systemBoundary: [
          { required: true, message: '请选择系统边界', trigger: 'change' },
        ],
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.userInfo;
      // return this.$cookies.get("isLogin")
    },
  },
  created() {
    if (this.certificate && this.certificate.length > 0) {
      this.formList = JSON.parse(
        JSON.stringify(
          this.certificate.map((item) => {
            item.carbonUnitValue = item.carbonUnitValue || '';
            // item.timeBoundary = item.timeBoundary.split('-');
            // item.validityPeriod = item.validityPeriod.split('-');
            if (item.timeBoundaryStart && item.timeBoundaryEnd)
              item.timeBoundary = [
                item.timeBoundaryStart,
                item.timeBoundaryEnd,
              ];
            if (item.validStart && item.validEnd)
              item.validityPeriod = [item.validStart, item.validEnd];
            if (item.categoryName)
              item.certificateMaterialCategory = [
                {
                  categoryName: item.categoryName,
                  categoryId: item.categoryId,
                },
              ];
            if (item.attachmentUrl)
              item.attachmentList = [
                { name: item.attachmentName, url: item.attachmentUrl },
              ];
            return item;
          })
        )
      );
    }
  },
  mounted() {},
  methods: {
    carbonUnitChange(index) {
      this.formList[index].carbonUnitValue = '';
    },
    uploadSuccess(res, index) {
      console.log(res);
      if (res.success) {
        this.formList[index].attachmentList = [
          {
            ...res.data,
            name: res.data.fileName,
            url: res.data.url,
          },
        ];
      }
    },
    deleteCertificate(index) {
      this.formList.splice(index, 1);
    },
    addCertificate() {
      this.formList.push({
        institutionName: '',
        reportCode: '',
        validityPeriod: [],
        standard: '',
        standardName: '',
        productName: '',
        certificateMaterialCategory: [],
        specifications: '',
        systemBoundary: '',
        timeBoundary: [],
        functionalUnit: '',
        carbonUnit: '',
        carbonUnitValue: '',
        attachmentList: [],
      });
    },
    CategoryChange(value, index) {
      this.formList[index].certificateMaterialCategory = value;
    },
    submit() {
      return new Promise((resolve, reject) => {
        const validatePromises = this.formList.map((_, index) => {
          // 注意 v-for 下的 ref 是数组，所以要 [0]
          return this.$refs[`ruleForm${index}`][0].validate();
        });

        Promise.all(validatePromises)
          .then(() => {
            console.log('✅ 全部验证通过', this.formList);
            const params = this.getParams();
            resolve({
              success: true,
              data: params,
            });
            // 这里写提交接口
          })
          .catch(() => {
            console.log('❌ 有表单没通过验证');
            reject();
          });
      });
      // 把所有表单的 validate() 都转成 Promise
    },
    getParams() {
      return this.formList.map((_) => {
        if (typeof _.timeBoundary !== 'string')
          // _.timeBoundary = _.timeBoundary.join('-');
          // if (typeof _.validityPeriod !== 'string')
          //   _.validityPeriod = _.validityPeriod.join('-');
          _.timeBoundaryStart = _.timeBoundary && _.timeBoundary[0];
        _.timeBoundaryEnd = _.timeBoundary && _.timeBoundary[1];
        _.validStart = _.validityPeriod && _.validityPeriod[0];
        _.validEnd = _.validityPeriod && _.validityPeriod[1];
        _.categoryName =
          _.certificateMaterialCategory &&
          _.certificateMaterialCategory[0] &&
          _.certificateMaterialCategory[0].categoryName;
        _.categoryId =
          _.certificateMaterialCategory &&
          _.certificateMaterialCategory[0] &&
          _.certificateMaterialCategory[0].categoryId;
        _.attachmentUrl =
          _.attachmentList && _.attachmentList[0] && _.attachmentList[0].url;
        _.attachmentName =
          _.attachmentList && _.attachmentList[0] && _.attachmentList[0].name;
        return _;
      });
    },
    handleInput(val, index, key) {
      const clean = val
        .replace(/[^\d.]/g, '') // 只能数字和 .
        .replace(/^(\d*\.\d*?)\..*$/, '$1') // 只保留一个小数点
        .replace(/^0+(\d)/, '$1'); // 避免开头多个0
      this.formList[index][key] = clean;
    },
    save() {
      return this.getParams();
    },
  },
};
</script>

<style lang="scss" scoped>
.certificate-title {
  width: 100%;
  height: 34px;
  margin-bottom: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(217, 217, 217, 1);
  .certificate-title-text {
    position: relative;
    font-size: 14px;
    line-height: 24px;
    // font-family: PingFangSC-Medium;
    color: rgba(51, 51, 51, 1);
    padding-left: 10px;
    &::before {
      content: '';
      position: absolute;
      top: 0px;
      left: 0px;
      width: 80px;
      height: 24px;
      background: linear-gradient(
        90deg,
        rgba(102, 171, 254, 0.5) 0%,
        rgba(73, 151, 246, 0) 100%
      );
    }
  }
}
.add-from {
  margin-top: 10px;
}
::v-deep .el-form-item {
  .el-form-item__label {
    padding: 0px;
    padding-right: 10px;
    color: #666;
  }
  .el-form-item__label:after {
    content: '';
    display: none;
  }
}
::v-deep .el-form-item.cursor-form-item {
  .el-form-item__label {
    line-height: 1;
  }
}
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: '*';
  color: rgba(240, 37, 15, 1);
  margin-right: 0px !important;
  /* margin-right: 4px; */
}
::v-deep .el-form .el-input__inner,
::v-deep .el-form .el-input,
::v-deep .el-form .el-date-editor,
::v-deep .el-form .el-select .el-input__inner,
::v-deep .el-form .el-select .el-input__inner,
::v-deep .el-input--small .el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}
::v-deep .el-radio {
  margin-right: 0px;
}
::v-deep .remark {
  padding-left: 0px !important;
}
</style>
